import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    Cell,
    ResponsiveContainer,
} from "recharts";

import {
    Card,
    Row,
    Col,
    Typography,
    DatePicker,
    Select,
    Form,
    Table,
    Progress,
    Space
} from "antd";
// import ViewEmpCalendar from "./ViewEmpCalendar";
import { useState, useEffect, useContext } from "react";
import dayjs from "dayjs";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import LeaveCalendar from "./employee/LeaveCalendar";

const { Title, Text } = Typography;
const { Option } = Select;

export default function ViewOneEmpPerm({ employee, isProfile }) {
    const currentMonth = dayjs().month() + 1;
    const currentYear = dayjs().year();
    const { authData, backUrl } = useContext(AuthContext);
    const [leaves_taken_breakdown, setLeavesTakenBreakdown] = useState({});

    // ✅ Normalize: support both direct employee object and nested employee.employee
    const emp = employee?.employee ?? employee;

    useEffect(() => {
        setLeavesTakenBreakdown(employee.leaves_taken_breakdown);
    });

    const [graphData, setGraphData] = useState({
        month: currentMonth,
        year: currentYear,
    });
    const [totalLeaves, setTotalLeaves] = useState([]);

    // ✅ Fetch permissions with month and year as query params
    const fetchTotalLeaves = async () => {
        try {
            const params = { employee: emp?.id };
            if (graphData.month) params.month = graphData.month;
            if (graphData.year) params.year = graphData.year;

            const res = await axios.get(`${backUrl}/api/hr/permissions/`, {
                params,
                headers: {
                    Authorization: `Bearer ${authData?.access}`,
                },
            });
            setTotalLeaves(res.data.results || []);
        } catch (err) {
            console.error("Error fetching permissions:", err);
        }
    };

    // ✅ Re-fetch whenever employee, month, or year changes
    useEffect(() => {
        if (emp?.id) fetchTotalLeaves();
    }, [employee, graphData.month, graphData.year]);

    // ✅ Data already filtered by backend
    const filteredLeaves = totalLeaves;

    const handleMonthChange = (date) => {
        setGraphData((prev) => ({
            ...prev,
            month: date ? date.month() + 1 : "",
        }));
    };

    const handleYearChange = (value) => {
        setGraphData((prev) => ({ ...prev, year: value }));
    };

    const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

    const leaveColumns = [
        { title: "Session", dataIndex: "session", key: "session" },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            render: (date) => dayjs(date).format("DD/MM/YYYY"),
        },
        {
            title: "Time",
            dataIndex: "time",
            key: "time",
        },
        {
            title: "Reason",
            dataIndex: "reason",
            key: "reason",
            width: 300,
            render: (text) => (
                <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                    {text}
                </div>
            ),
        },
        { title: "Hours Requested", dataIndex: "hours_requested", key: "hours_requested" },
        {
            title: "Status",
            dataIndex: "approve_status",
            key: "approve_status",
            render: (status) => (
                <span
                    style={{
                        color:
                            status === "Approved"
                                ? "green"
                                : status === "Rejected"
                                    ? "red"
                                    : "orange",
                        fontWeight: 500,
                    }}
                >
                    {status}
                </span>
            ),
        },
    ];

    return (
        <Card bordered={false} style={{ margin: "5px", width: "100%" }}>
            {/* ✅ Month / Year Filters */}
            <Form
                layout="inline"
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: "10px",
                    marginBottom: "20px",
                }}
            >
                <Form.Item label="Month">
                    <DatePicker
                        picker="month"
                        onChange={handleMonthChange}
                        allowClear
                        value={graphData.month ? dayjs().month(graphData.month - 1) : null}
                        style={{ width: 160 }}
                    />
                </Form.Item>

                <Form.Item label="Year">
                    <Select
                        style={{ width: 140 }}
                        placeholder="Select Year"
                        onChange={handleYearChange}
                        allowClear
                        value={graphData.year}
                    >
                        {years.map((yr) => (
                            <Option key={yr} value={yr}>
                                {yr}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>

            {/* ✅ Permission Table */}
            <Table
                columns={leaveColumns}
                dataSource={filteredLeaves.map((item) => ({
                    ...item,
                    key: item.id,
                }))}
                pagination={{ pageSize: 5, responsive: true }}
                scroll={{ x: "max-content" }}
                components={{
                    header: {
                        cell: (props) => (
                            <th
                                {...props}
                                style={{
                                    backgroundColor: "#0e497b",
                                    color: "white",
                                    textAlign: "center",
                                }}
                            >
                                {props.children}
                            </th>
                        ),
                    },
                }}
            />

            {!isProfile && (
                <>
                </>
            )}
        </Card>
    );
}